<template>
  <div class="mobile-modal-overlay bg-[rgba(0,0,0,0.6)] fixed inset-0 z-2000 flex items-end justify-center" @click.self="$emit('close')">
    <div class="mobile-modal-content bg-white w-full rounded-t-2xl shadow-lg">
      <div class="p-6 space-y-6">
        <div class="text-center text-[#0033A0] text-xl font-bold mb-6 ">
          Meeting Info
        </div>
        <div class="space-y-6 pt-2">
          <!-- Meeting ID -->
          <div>
            <p class="text-sm text-[#0033A0] mb-2 font-semibold">Meeting ID</p>
            <div class="flex items-center justify-between p-4 bg-[#E8EFF5] rounded-2xl">
              <span class="text-lg font-mono text-[#1A1A1A] tracking-widest">{{ meetingId }}</span>
              <button
                @click="$emit('copy')"
                :class="isCopied ? 'bg-green-500' : 'border-2 border-[#0033A0] text-[#0033A0] hover:bg-[rgba(0,51,160,0.05)]'"
                class="rounded-2xl w-10 h-10 flex items-center justify-center transition-colors duration-150"
              >
                <svg v-if="isCopied" xmlns="http://www.w3.org/2000/svg" class="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <polyline points="20 6 9 17 4 12"></polyline>
                </svg>
                <svg v-else xmlns="http://www.w3.org/2000/svg" class="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect>
                  <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path>
                </svg>
              </button>
            </div>
          </div>

          <!-- Participants -->
          <div>
            <p class="text-sm text-[#0033A0] mb-2 font-semibold">
              Participants ({{ participants.length + 1 }})
            </p>
            <div class="space-y-3 max-h-48 overflow-y-auto pr-2">
              <!-- Current user -->
              <div class="flex items-center justify-between p-2 bg-[rgba(0,51,160,0.1)] rounded-2xl">
                <div class="flex items-center gap-3">
                  <div class="w-8 h-8 rounded-full bg-[#0033A0] flex items-center justify-center font-bold text-white">
                    {{ user.name.charAt(0).toUpperCase() }}
                  </div>
                  <span class="font-medium text-[#1A1A1A]">{{ user.name }} (You)</span>
                </div>
                <span class="text-xs bg-[#0033A0] text-white px-2 py-1 rounded-full font-bold">
                  {{ getLanguageName(user.language) }}
                </span>
              </div>
              <!-- Other participants -->
              <div
                v-for="participant in participants"
                :key="participant.id"
                class="flex items-center justify-between p-2 bg-[#E8EFF5] rounded-2xl"
              >
                <span class="text-[#1A1A1A]">{{ participant.name }}</span>
                <span class="text-xs bg-[#0033A0] text-white px-2 py-1 rounded-full font-bold">
                  {{ getLanguageName(participant.language) }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  meetingId: {
    type: String,
    required: true
  },
  isCopied: {
    type: Boolean,
    default: false
  },
  user: {
    type: Object,
    required: true
  },
  participants: {
    type: Array,
    required: true
  },
  languages: {
    type: Array,
    required: true
  }
})

defineEmits(['close', 'copy'])

const getLanguageName = (code) => {
  return props.languages.find((lang) => lang.code === code)?.name || code
}
</script>

<style scoped>
.trava-logo {
  font-family: 'Zen Tokyo Zoo', sans-serif;
  letter-spacing: 0.1em;
}
.modal-enter-active,
.modal-leave-active {
  transition: opacity 0.3s ease;
}
.modal-enter-from,
.modal-leave-to {
  opacity: 0;
}
</style>
